import React, {useContext} from 'react'
import classes from './ModalSuccess.module.scss'
import success from './images/success.png';
import { LanguageContext } from '../../../containers/Language';

export const ModalSuccess = () => {

    const {dictionary} = useContext(LanguageContext);

    return (
        <div className={classes.success}>
            <img src={success} alt='success'  />
            <h1>{dictionary.SUCC_MESS}</h1>
            <h5>{dictionary.SUCC_MESS_INFO}</h5>
        </div>
    )
}
